import 'bootstrap/dist/css/bootstrap-grid.min.css';

import React from 'react';
import * as Sentry from '@sentry/react';
import { pixelInit, pixelPage } from './app/utils/pixel';
import Router from './app/router/Router';
import CookiesMessage from './app/components/CookiesMessage';
import GoogleTagManager from './app/components/GoogleTagManager/GoogleTagManager';

class App extends React.Component {
  componentDidMount () {
    pixelInit();
    pixelPage();
  }
  render () {
    return (
      <Sentry.ErrorBoundary fallback={<div></div>}>
        <div>
          <GoogleTagManager />
          <Router />
          <CookiesMessage />
        </div>
      </Sentry.ErrorBoundary>
    );
  }
}

export default App;
